import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledDocumentTemplateForm = styled(StyledFlex)`
   overflow: hidden;
`;
